import React from "react";
import FileUploadUsers from "../components/users/FileUploadUser";

const Content = () => {
  return (
    <div className="space-y-5">      
      <FileUploadUsers />      
    </div>
  );
};

export default Content;
